import { render, staticRenderFns } from "./FloatingWhatsapp.vue?vue&type=template&id=09147914&scoped=true"
import script from "./FloatingWhatsapp.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./FloatingWhatsapp.vue?vue&type=style&index=0&id=09147914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09147914",
  null
  
)

export default component.exports